import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ProjectDeleteModalService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following AngularJS ProjectService.deleteProjectData pattern exactly
  deleteProjectData(
    baseUrl: string,
    deleteData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action code exactly like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=7c0ztf`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure exactly like ProjectService
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // 🚀 CRITICAL: Add required configuration parameters with proper fallbacks
    params.tax_year = filterParams?.tax_year || globalService?.globalParams?.tax_year || rowData?.TAX_YEAR || new Date().getFullYear();
    params.scenario = filterParams?.scenario || globalService?.globalParams?.scenario || rowData?.SCENARIO || 74;
    params.jcd_key = filterParams?.jcd_key || globalService?.globalParams?.jcd_key || rowData?.JCD_KEY || 250;
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.globalParams?.scenarioCode || globalService?.globalParams?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    
    // Build JSON object exactly like AngularJS service
    const jsonObj = JSON.stringify(deleteData || []);
    
    // Extend with clob_data exactly like AngularJS
    params = _.extend({
      sso_id: globalService?.globalParams?.sso_id || filterParams?.sso_id || '',
      clob_data: jsonObj
    }, params);
    
    // Set process_name exactly like AngularJS (empty string)
    params.process_name = "";

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // 🚀 CRITICAL: Following AngularJS ProjectStepFactory.deleteProjectStepData pattern exactly
  deleteProjectStepData(
    baseUrl: string,
    deleteData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action code exactly like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=k3gshw`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure exactly like ProjectStepFactory
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // 🚀 CRITICAL: Add required configuration parameters with proper fallbacks
    params.tax_year = filterParams?.tax_year || globalService?.globalParams?.tax_year || rowData?.TAX_YEAR || new Date().getFullYear();
    params.scenario = filterParams?.scenario || globalService?.globalParams?.scenario || rowData?.SCENARIO || 74;
    params.jcd_key = filterParams?.jcd_key || globalService?.globalParams?.jcd_key || rowData?.JCD_KEY || 250;
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.globalParams?.scenarioCode || globalService?.globalParams?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';

    
    // Build JSON object exactly like AngularJS service
    const jsonObj = JSON.stringify(deleteData || []);
    
    // Extend with clob_data exactly like AngularJS
    params = _.extend({
      sso_id: globalService?.globalParams?.sso_id || filterParams?.sso_id || '',
      clob_data: jsonObj
    }, params);
    
    // Set process_name exactly like AngularJS (empty string)
    params.process_name = "";

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
